import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { Spinner, Modal, Container } from 'react-bootstrap';
import {
  IoList,
  IoLogoWhatsapp,
  IoShareSocial,
  IoCalendar,
  IoPeople,
  IoArrowBack,
} from 'react-icons/io5';
import { LuArrowUpRight, LuFileEdit, LuMoreVertical } from 'react-icons/lu';

import { toastr } from 'react-redux-toastr';

import { PageHeader, Tabs, Button, Dropdown } from '_components/_core';

import FORMATTERS from 'helpers/formatters';
import eventsActionCreators from '_store/_actions/events';

import WhatsAppConfigModal from '../WhatsAppConfigModal';
import SendWhatsAppNotificationModal from '../SendWhatsAppNotificationModal';
import EventRegistrations from '../EventRegistrations/EventRegistrationsContainer';

import { StyledStats, StyledStatItem } from '../../styles';

function EventManagement({
  event,
  registrations,
  whatsAppConfigs,
  isLoading,
  onFetchEvent,
  onFetchEventRegistrations,
  onFetchWhatsAppConfigs,
  onDeleteEventRegistration,
  onGenerateEventShareUrl,
}) {
  const { id } = useParams();
  const history = useHistory();
  const [shareUrl, setShareUrl] = useState('');
  const [showShareModal, setShowShareModal] = useState(false);
  const [showWhatsAppConfigModal, setShowWhatsAppConfigModal] = useState(false);
  const [showSendNotificationModal, setShowSendNotificationModal] = useState(false);
  const [currentConfig, setCurrentConfig] = useState(null);
  const [activeTab, setActiveTab] = useState('registrations');

  useEffect(() => {
    if (id) {
      onFetchEvent(id);
      onFetchEventRegistrations(id);
      onFetchWhatsAppConfigs(id);
    }
  }, [id, onFetchEvent, onFetchEventRegistrations, onFetchWhatsAppConfigs]);

  const handleGenerateShareUrl = async () => {
    try {
      const url = await onGenerateEventShareUrl(id);

      setShareUrl(url);
      setShowShareModal(true);
    } catch (err) {
      toastr.error(
        'Error',
        `Failed to generate share URL: ${err.message || 'Unknown error'}`,
      );
    }
  };

  const handleViewForm = () => {
    window.open(`/eventos/${id}/inscricao`);
  };

  const handleCopyShareUrl = () => {
    navigator.clipboard.writeText(shareUrl);
    toastr.success('Success', 'URL copied to clipboard');
  };

  const handleEditWhatsAppConfig = config => {
    setCurrentConfig(config);
    setShowWhatsAppConfigModal(true);
  };

  const handleSendWhatsAppNotification = config => {
    setCurrentConfig(config);
    setShowSendNotificationModal(true);
  };

  const formatDate = dateString => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const getTabs = useCallback(() => {
    return [
      {
        id: 'registrations',
        title: 'Inscrições',
        content: activeTab === 'registrations' && (
          <EventRegistrations eventId={id} event={event} />
        ),
      },
      // {
      //   id: 'details',
      //   title: 'Detalhes',
      //   content: (
      //     <>
      //       <div className="d-flex justify-content-between mb-3">
      //         <h5>WhatsApp Notification Templates</h5>
      //         <Button
      //           variant="outline-primary"
      //           size="sm"
      //           onClick={() => setShowWhatsAppConfigModal(true)}
      //         >
      //           Add Template
      //         </Button>
      //       </div>
      //       {whatsAppConfigs?.data?.length > 0 ? (
      //         <Table hover responsive>
      //           <thead>
      //             <tr>
      //               <th>Name</th>
      //               <th>Template</th>
      //               <th>Created Date</th>
      //               <th>Actions</th>
      //             </tr>
      //           </thead>
      //           <tbody>
      //             {whatsAppConfigs.data.map(config => (
      //               <tr key={config._id}>
      //                 <td>{config.name}</td>
      //                 <td>
      //                   <div
      //                     style={{
      //                       maxWidth: '300px',
      //                       whiteSpace: 'nowrap',
      //                       overflow: 'hidden',
      //                       textOverflow: 'ellipsis',
      //                     }}
      //                   >
      //                     {config.template}
      //                   </div>
      //                 </td>
      //                 <td>{formatDate(config.created_at)}</td>
      //                 <td>
      //                   <Button
      //                     variant="outline-primary"
      //                     size="sm"
      //                     className="mr-2"
      //                     onClick={() => handleEditWhatsAppConfig(config)}
      //                   >
      //                     Edit
      //                   </Button>
      //                   <Button
      //                     variant="outline-success"
      //                     size="sm"
      //                     onClick={() => handleSendWhatsAppNotification(config)}
      //                   >
      //                     Send
      //                   </Button>
      //                 </td>
      //               </tr>
      //             ))}
      //           </tbody>
      //         </Table>
      //       ) : (
      //         <div className="text-center py-5">
      //           <p className="text-muted">No WhatsApp templates configured</p>
      //           <Button
      //             variant="primary"
      //             onClick={() => setShowWhatsAppConfigModal(true)}
      //           >
      //             Create WhatsApp Template
      //           </Button>
      //         </div>
      //       )}
      //     </>
      //   ),
      // },
      // {
      //   id: 'customFields',
      //   title: 'Formulário de Inscrição',
      //   content: (
      //     <>
      //       <h5>Custom Registration Form Fields</h5>
      //       {event.custom_fields?.length > 0 ? (
      //         <Table hover responsive>
      //           <thead>
      //             <tr>
      //               <th>Field Name</th>
      //               <th>Label</th>
      //               <th>Type</th>
      //               <th>Required</th>
      //             </tr>
      //           </thead>
      //           <tbody>
      //             {event.custom_fields.map((field, index) => (
      //               <tr key={index}>
      //                 <td>{field.name}</td>
      //                 <td>{field.label}</td>
      //                 <td>{field.type}</td>
      //                 <td>{field.required ? 'Yes' : 'No'}</td>
      //               </tr>
      //             ))}
      //           </tbody>
      //         </Table>
      //       ) : (
      //         <div className="text-center py-5">
      //           <p className="text-muted">No custom fields configured</p>
      //           <Button
      //             variant="primary"
      //             onClick={() => history.push(`/events/edit/${id}`)}
      //           >
      //             Add Custom Fields
      //           </Button>
      //         </div>
      //       )}
      //     </>
      //   ),
      // },
    ];
  }, [id, activeTab, event]);

  if (isLoading || !event) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Container fluid className="content-wrapper">
      <Button
        variant="link"
        className="m-0 p-0 d-flex align-items-center"
        onClick={() => history.goBack()}
      >
        <IoArrowBack className="mr-2" /> Voltar
      </Button>
      <PageHeader
        title={event.name}
        description={
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center text-muted mb-2">
              <IoCalendar className="mr-2" />
              <span>
                {`${FORMATTERS.DATE_FRIENDLY(event.start_date)} - ${FORMATTERS.DATE_FRIENDLY(event.end_date)}`}
              </span>
            </div>
          </div>
        }
        className="ml-3"
        sideContent={
          <div className="d-flex align-items-center">
            <Button
              variant="white"
              className="d-flex align-items-center justify-content-center"
              onClick={() => history.push(`/eventos/${id}/editar`)}
            >
              <LuFileEdit className="mr-2" /> Editar
            </Button>
            <Dropdown
              placement="bottom-start"
              options={[
                {
                  label: 'Copiar link',
                  icon: <IoShareSocial />,
                  onClick: handleGenerateShareUrl,
                },
                {
                  label: 'Formulário',
                  icon: <LuArrowUpRight />,
                  onClick: handleViewForm,
                  disabled: false,
                },
              ]}
            >
              <Button
                variant="white"
                className="d-flex align-items-center justify-content-center ml-2"
                onClick={handleGenerateShareUrl}
              >
                <LuMoreVertical className="mr-2" /> Ações
              </Button>
            </Dropdown>
          </div>
        }
      />
      <hr />
      <StyledStats>
        <StyledStatItem>
          <div className="stat-value">
            {registrations?.data?.length || 0}/{event.capacity || 'Unlimited'}
          </div>
          <div className="stat-label">
            <IoPeople className="mr-2" />
            Inscrições
          </div>
        </StyledStatItem>

        <StyledStatItem>
          <div className="stat-value">{whatsAppConfigs?.data?.length || 0}</div>
          <div className="stat-label">
            <IoLogoWhatsapp className="mr-2" />
            WhatsApp Templates
          </div>
        </StyledStatItem>

        <StyledStatItem>
          <div className="stat-value">{event.custom_fields?.length || 0}</div>
          <div className="stat-label">
            <IoList className="mr-2" />
            Campos do Formulário
          </div>
        </StyledStatItem>
      </StyledStats>
      <Tabs
        variant="secondary"
        activeTab={activeTab}
        onTabChange={tab => {
          setActiveTab(tab);
        }}
        tabs={getTabs()}
      />
      {/* <Card className="mt-4">
        <Card.Body>
          {activeTab === 'registrations' && (
            <>
              <div className="d-flex justify-content-between mb-3">
                <h5>Inscrições ({registrations?.total || 0})</h5>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => history.push(`/events/${id}/registrations/new`)}
                >
                  Adicionar Inscrição
                </Button>
              </div>
              {registrations?.data?.length > 0 ? (
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Status</th>
                      <th>Registration Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registrations.data.map(registration => (
                      <tr key={registration._id}>
                        <td>{registration.name}</td>
                        <td>{registration.email}</td>
                        <td>{registration.phone}</td>
                        <td>
                          {registration.status === 'waitlist' ? (
                            <Badge variant="warning">Waitlist</Badge>
                          ) : (
                            <Badge variant="success">Confirmed</Badge>
                          )}
                        </td>
                        <td>{formatDate(registration.created_at)}</td>
                        <td>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="mr-2"
                            onClick={() =>
                              history.push(
                                `/events/${id}/registrations/${registration._id}`,
                              )
                            }
                          >
                            View
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteRegistration(registration._id)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center py-5">
                  <p className="text-muted">No registrations yet</p>
                  <Button variant="primary" onClick={handleGenerateShareUrl}>
                    Generate Registration Link
                  </Button>
                </div>
              )}
            </>
          )}

          {activeTab === 'whatsapp' && (
            <>
              <div className="d-flex justify-content-between mb-3">
                <h5>WhatsApp Notification Templates</h5>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => setShowWhatsAppConfigModal(true)}
                >
                  Add Template
                </Button>
              </div>
              {whatsAppConfigs?.data?.length > 0 ? (
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Template</th>
                      <th>Created Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {whatsAppConfigs.data.map(config => (
                      <tr key={config._id}>
                        <td>{config.name}</td>
                        <td>
                          <div
                            style={{
                              maxWidth: '300px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {config.template}
                          </div>
                        </td>
                        <td>{formatDate(config.created_at)}</td>
                        <td>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="mr-2"
                            onClick={() => handleEditWhatsAppConfig(config)}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => handleSendWhatsAppNotification(config)}
                          >
                            Send
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center py-5">
                  <p className="text-muted">No WhatsApp templates configured</p>
                  <Button
                    variant="primary"
                    onClick={() => setShowWhatsAppConfigModal(true)}
                  >
                    Create WhatsApp Template
                  </Button>
                </div>
              )}
            </>
          )}

          {activeTab === 'forms' && (
            <>
              <h5>Custom Registration Form Fields</h5>
              {event.custom_fields?.length > 0 ? (
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Field Name</th>
                      <th>Label</th>
                      <th>Type</th>
                      <th>Required</th>
                    </tr>
                  </thead>
                  <tbody>
                    {event.custom_fields.map((field, index) => (
                      <tr key={index}>
                        <td>{field.name}</td>
                        <td>{field.label}</td>
                        <td>{field.type}</td>
                        <td>{field.required ? 'Yes' : 'No'}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center py-5">
                  <p className="text-muted">No custom fields configured</p>
                  <Button
                    variant="primary"
                    onClick={() => history.push(`/events/edit/${id}`)}
                  >
                    Add Custom Fields
                  </Button>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card> */}

      {/* Share URL Modal */}
      <Modal show={showShareModal} onHide={() => setShowShareModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Share Event Registration Link</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Share this URL to allow people to register for your event:</p>
          <div className="input-group">
            <input type="text" className="form-control" value={shareUrl} readOnly />
            <div className="input-group-append">
              <Button variant="outline-secondary" onClick={handleCopyShareUrl}>
                Copy
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowShareModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* WhatsApp Config Modal - This would be a separate component */}
      {showWhatsAppConfigModal && (
        <WhatsAppConfigModal
          show={showWhatsAppConfigModal}
          onHide={() => {
            setShowWhatsAppConfigModal(false);
            setCurrentConfig(null);
          }}
          eventId={id}
          config={currentConfig}
          onSuccess={() => {
            setShowWhatsAppConfigModal(false);
            setCurrentConfig(null);
            onFetchWhatsAppConfigs(id);
          }}
        />
      )}

      {/* Send WhatsApp Notification Modal - This would be a separate component */}
      {showSendNotificationModal && (
        <SendWhatsAppNotificationModal
          show={showSendNotificationModal}
          onHide={() => {
            setShowSendNotificationModal(false);
            setCurrentConfig(null);
          }}
          eventId={id}
          config={currentConfig}
          registrations={registrations?.data || []}
        />
      )}
    </Container>
  );
}

EventManagement.propTypes = {
  event: PropTypes.object,
  registrations: PropTypes.object,
  whatsAppConfigs: PropTypes.object,
  isLoading: PropTypes.bool,
  onFetchEvent: PropTypes.func.isRequired,
  onFetchEventRegistrations: PropTypes.func.isRequired,
  onFetchWhatsAppConfigs: PropTypes.func.isRequired,
  onDeleteEventRegistration: PropTypes.func.isRequired,
  onGenerateEventShareUrl: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  event: state.events.event,
  registrations: state.events.registrations,
  whatsAppConfigs: state.events.whatsAppConfigs,
  isLoading: state.events.isLoading,
});

const mapDispatchToProps = {
  onFetchEvent: eventsActionCreators.fetchEvent,
  onFetchEventRegistrations: eventsActionCreators.fetchEventRegistrations,
  onFetchWhatsAppConfigs: eventsActionCreators.fetchWhatsAppConfigs,
  onDeleteEventRegistration: eventsActionCreators.deleteEventRegistration,
  onGenerateEventShareUrl: eventsActionCreators.generateEventShareUrl,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventManagement);
